import { useEffect, useState } from "react";
import "./users.css";
import { Bounce, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import api from "../api";
import CustomSelect from "../CustomSelect";

const AddUser = () => {
  const [loading, setLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [email, setEmail] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [inputErrors, setInputErrors] = useState({});
  const [sedi, setSedi] = useState([]);
  const [selectedSedi, setSelectedSedi] = useState([]);
  const [tipologia, setTipologia] = useState("");
  const navigate = useNavigate();

  const emailRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const nameRegEx = /^[A-Za-zÀ-ÿ' -]{2,50}$/;

  const isValid = () => {
    const errors = {};

    if (!nome) {
      errors.nome = "Il campo Nome non può essere vuoto!";
    } else if (!nameRegEx.test(nome)) {
      errors.nome = "Il campo Nome può contenere solo lettere!";
    }

    if (!cognome) {
      errors.cognome = "Il campo Cognome non può essere vuoto!";
    } else if (!nameRegEx.test(cognome)) {
      errors.cognome = "Il campo Cognome può contenere solo lettere!";
    }

    if (!email) {
      errors.email = "Il campo Email non può essere vuoto!";
    } else if (!emailRegEx.test(email)) {
      errors.email = "Il formato del campo Email non è valido!";
    }

    if (!tipologia) {
      errors.tipologia = "Il campo Ruolo utente non può essere vuoto!";
    }

    if (selectedSedi.length === 0) {
      errors.sedi = "Seleziona almeno una sede!";
    }

    setInputErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const fetchSedi = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/sedi`);
      if (response.status === 200) {
        setSedi(response.data);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per aggiungere utenti!");
      navigate("/login");
      localStorage.clear();
    } else {
      setIsAuthorized(true);
      fetchSedi();
    }
  }, [navigate]);

  const addOperatore = async () => {
    if (!isValid()) return;

    try {
      setLoading(true);
      const response = await api.post("/users", {
        nome,
        cognome,
        tipologia,
        email,
        descrizione,
        sedeIds: selectedSedi,
      });

      if (response.status === 201) {
        toast.success("Utente creato con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });

        setNome("");
        setCognome("");
        setEmail("");
        setSelectedSedi([]);
        setDescrizione("");
        setTipologia("");
      }
    } catch (error) {
      console.error(error);

      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthorized) return null;

  const options = sedi.map((sede) => ({
    value: sede.idSede,
    label: sede.indirizzoSede,
  }));

  const selectedOptions = options.filter((option) =>
    selectedSedi.includes(option.value)
  );

  const handleSelectChange = (selected) => {
    if (selected) {
      setSelectedSedi(selected.map((option) => option.value));
      setInputErrors((prev) => ({ ...prev, sedi: "" }));
    } else {
      setSelectedSedi([]);
      setInputErrors((prev) => ({ ...prev, sedi: "" }));
    }
  };

  const roleOptions = [
    { value: "Administrator", label: "Administrator" },
    { value: "Operatore", label: "Operatore" },
  ];

  const handleNomeChange = (e) => {
    setNome(e.target.value);
    setInputErrors((prev) => ({ ...prev, nome: "" }));
  };

  const handleCognomeChange = (e) => {
    setCognome(e.target.value);
    setInputErrors((prev) => ({ ...prev, cognome: "" }));
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setInputErrors((prev) => ({ ...prev, email: "" }));
  };

  const handleDescrizioneChange = (e) => {
    setDescrizione(e.target.value);
    setInputErrors((prev) => ({ ...prev, descrizione: "" }));
  };

  const handleTipologiaChange = (selectedOption) => {
    setTipologia(selectedOption ? selectedOption.value : "");
    setInputErrors((prev) => ({ ...prev, tipologia: "" }));
  };

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Aggiungi Utente</div>
        <div className="header-actions">
          <button onClick={() => navigate("/utenti")} className="back-btn">
            <i className="fa-solid fa-arrow-left"></i>
            Torna agli Utenti
          </button>
        </div>
      </div>

      <div className="page-content add-user-container">
        <div className="add-user-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-user-plus"></i>
              Nuovo Utente
            </div>
          </div>

          <div className="card-content">
            <div className="form-grid">
              <div className="form-field">
                <label className="field-label">
                  <i className="fa-solid fa-user"></i>
                  Nome
                </label>
                <div className="field-input">
                  <input
                    type="text"
                    value={nome}
                    onChange={handleNomeChange}
                    placeholder="Inserisci il nome"
                    className={inputErrors.nome ? "error-input" : ""}
                  />
                  {inputErrors.nome && (
                    <div className="error-message">{inputErrors.nome}</div>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="field-label">
                  <i className="fa-solid fa-user"></i>
                  Cognome
                </label>
                <div className="field-input">
                  <input
                    type="text"
                    value={cognome}
                    onChange={handleCognomeChange}
                    placeholder="Inserisci il cognome"
                    className={inputErrors.cognome ? "error-input" : ""}
                  />
                  {inputErrors.cognome && (
                    <div className="error-message">{inputErrors.cognome}</div>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="field-label">
                  <i className="fa-solid fa-envelope"></i>
                  Email
                </label>
                <div className="field-input">
                  <input
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Inserisci l'email"
                    className={inputErrors.email ? "error-input" : ""}
                  />
                  {inputErrors.email && (
                    <div className="error-message">{inputErrors.email}</div>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="field-label">
                  <i className="fa-solid fa-user-tag"></i>
                  Tipologia
                </label>
                <div className="field-input">
                  <CustomSelect
                    options={roleOptions}
                    value={
                      roleOptions.find((opt) => opt.value === tipologia) || null
                    }
                    onChange={handleTipologiaChange}
                    placeholder="Seleziona il ruolo"
                    className={inputErrors.tipologia ? "error-input" : ""}
                  />
                  {inputErrors.tipologia && (
                    <div className="error-message">{inputErrors.tipologia}</div>
                  )}
                </div>
              </div>

              <div className="form-field full-width">
                <label className="field-label">
                  <i className="fa-solid fa-building"></i>
                  Sedi
                </label>
                <div className="field-input">
                  <CustomSelect
                    options={options}
                    value={selectedOptions}
                    onChange={handleSelectChange}
                    placeholder="Seleziona le sedi"
                    isMulti
                    className={inputErrors.sedi ? "error-input" : ""}
                  />
                  {inputErrors.sedi && (
                    <div className="error-message">{inputErrors.sedi}</div>
                  )}
                </div>
              </div>

              <div className="form-field full-width">
                <label className="field-label">
                  <i className="fa-solid fa-align-left"></i>
                  Descrizione
                </label>
                <div className="field-input">
                  <textarea
                    value={descrizione}
                    onChange={handleDescrizioneChange}
                    rows={4}
                    placeholder="Inserisci una descrizione"
                    className={inputErrors.descrizione ? "error-input" : ""}
                  />
                </div>
              </div>
            </div>

            <div className="action-buttons">
              <button
                className="cancel-btn"
                onClick={() => navigate("/utenti")}
              >
                <i className="fa-solid fa-times"></i>
                Annulla
              </button>
              <button className="save-btn" onClick={addOperatore}>
                <i className="fa-solid fa-plus"></i>
                Aggiungi Utente
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
